import { defineSeasonalIcon } from './seasonal-icon';

export enum ThanksgivingIcon {
  ACORN = 'acorn',
  APPLE = 'apple',
  BARN = 'barn',
  BASKET = 'basket',
  BONFIRE = 'bonfire',
  CABIN = 'cabin',
  CANDLE = 'candle',
  CARROT = 'carrot',
  CHEF_HAT = 'chefHat',
  CIDER_TOAST = 'ciderToast',
  COOKBOOK = 'cookbook',
  COOKING_POT = 'cookingPot',
  CORN = 'corn',
  CORNUCOPIA = 'cornucopia',
  CRANBERRY_SAUCE = 'cranberrySauce',
  DRUMSTICK = 'drumstick',
  FEATHER = 'feather',
  FOOTBALL = 'football',
  FORK_KNIFE = 'forkKnife',
  GRAPES = 'grapes',
  GRAVY_BOAT = 'gravyBoat',
  HAY_BALE = 'hayBale',
  HONEY_JAR = 'honeyJar',
  LEFTOVERS = 'leftovers',
  MAPLE_LEAF = 'mapleLeaf',
  MUFFIN = 'muffin',
  MUSHROOM = 'mushroom',
  OVEN = 'oven',
  OVEN_MITT = 'ovenMitt',
  PARADE_BALLOON = 'paradeBalloon',
  PEAR = 'pear',
  PIE = 'pie',
  PIE_SLICE = 'pieSlice',
  PILGRIM_HAT = 'pilgrimHat',
  PLATE_SETTING = 'plateSetting',
  PUMPKIN = 'pumpkin',
  ROLLING_PIN = 'rollingPin',
  SALT_SHAKER = 'saltShaker',
  SCARECROW = 'scarecrow',
  SHIP = 'ship',
  SILO = 'silo',
  SPOON = 'spoon',
  SQUASH = 'squash',
  SUNFLOWER = 'sunflower',
  TABLE = 'table',
  TRACTOR = 'tractor',
  TURKEY = 'turkey',
  WHISK = 'whisk',
  WISHBONE = 'wishbone',
}

// Outline icons in the Lucide style (24-grid, 1.8 rounded strokes), drawn for the harvest set.
const ICON_PATHS: Record<ThanksgivingIcon, string> = {
  [ThanksgivingIcon.ACORN]: 'M5 10c0-3 3-5 7-5s7 2 7 5zM12 5V2.5M6.5 10c0 6 2.5 11 5.5 11s5.5-5 5.5-11',
  [ThanksgivingIcon.APPLE]:
    'M12 7.5c-1.5-1.5-4-2-6-1-2.5 1.3-3.2 4.5-2.4 7.6.9 3.6 3.4 6.9 5.4 6.9 1.2 0 2-.6 3-.6s1.8.6 3 .6c2 0 4.5-3.3 5.4-6.9.8-3.1.1-6.3-2.4-7.6-2-1-4.5-.5-6 1zM12 7.5c0-2 .8-3.8 2.5-4.5',
  [ThanksgivingIcon.BARN]: 'M3 21V10l9-6 9 6v11zM9 21v-7h6v7M9 14l6 7M15 14l-6 7M10 9h4',
  [ThanksgivingIcon.BASKET]: 'M3 10h18l-2 10H5zM7 10l4-6M17 10l-4-6M9 13.5v3.5M12 13.5v3.5M15 13.5v3.5',
  [ThanksgivingIcon.BONFIRE]:
    'M12 3c.5 2.5 3.5 4 3.5 7.5a3.5 3.5 0 0 1-7 0c0-1.5.7-2.6 1.6-3.4.2 1.2.8 2 1.6 2.3-.3-2.3.1-4.5.3-6.4zM4 21l16-4M4 17l16 4',
  [ThanksgivingIcon.CABIN]: 'M3 10.5 12 3l9 7.5M5 9v12h14V9M10 21v-6h4v6M16 5V3h2v3.5',
  [ThanksgivingIcon.CANDLE]:
    'M12 2c1 1.3 1.6 2.3 1.6 3.2a1.6 1.6 0 0 1-3.2 0c0-.9.6-1.9 1.6-3.2zM9.5 9h5v10h-5zM5 19h14v2H5z',
  [ThanksgivingIcon.CARROT]:
    'M2.3 21.7s9.9-3.5 12.7-6.4a4.5 4.5 0 0 0-6.4-6.4C5.8 11.8 2.3 21.7 2.3 21.7zM8.6 14l-2-2M15.3 15l-2.5-2.5M22 9s-1.3-2-3.5-2C16.9 7 15 9 15 9s1.3 2 3.5 2S22 9 22 9zM15 2s-2 1.3-2 3.5S15 9 15 9s2-1.8 2-3.5C17 3.3 15 2 15 2z',
  [ThanksgivingIcon.CHEF_HAT]: 'M6 13.5a4 4 0 1 1 1.6-7.7 4.5 4.5 0 0 1 8.8 0A4 4 0 1 1 18 13.5V20H6zM6 16.5h12',
  [ThanksgivingIcon.CIDER_TOAST]:
    'M3.5 7.5 8.5 6l2 9-5 1.5zM20.5 7.5 15.5 6l-2 9 5 1.5zM7.8 16.4 8.4 21M16.2 16.4 15.6 21M6.5 21h4M13.5 21h4M12 2.5v2M9.5 3.5l.9 1.4M14.5 3.5l-.9 1.4',
  [ThanksgivingIcon.COOKBOOK]: 'M4 19.5V5a2 2 0 0 1 2-2h14v16H6a2 2 0 0 0 0 4h14v-4M10 7v3a2 2 0 0 0 4 0V7M12 12v4',
  [ThanksgivingIcon.COOKING_POT]: 'M3 10h18M5 10v8a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-8M7.5 7h9M12 4v3M2 12.5h1M21 12.5h1',
  [ThanksgivingIcon.CORN]:
    'M12 2.5c2 0 3 3.5 3 8s-1 7.5-3 7.5-3-3-3-7.5 1-8 3-8zM9.4 7.5h5.2M9 11h6M9.4 14.5h5.2M12 2.5V18M9 18c-3-1-5-4-6-8 3 1 5 3 6 6M15 18c3-1 5-4 6-8-3 1-5 3-6 6M12 18v3.5',
  [ThanksgivingIcon.CORNUCOPIA]:
    'M16.5 7.4C10 8.5 5.5 12.5 3 19c5-.3 10-2 14-4.4M16.8 7.3c-1.4.3-2.2 2.4-1.7 4.6s1.8 3.4 3.2 3.1M17.5 9.2M18.0 7.5a1.5 1.5 0 1 0 3.0 0a1.5 1.5 0 1 0 -3.0 0zM18.5 12.5a1.5 1.5 0 1 0 3.0 0a1.5 1.5 0 1 0 -3.0 0z',
  [ThanksgivingIcon.CRANBERRY_SAUCE]: 'M7 5h10v12H7zM7 9h10M7 13h10M3 20h18',
  [ThanksgivingIcon.DRUMSTICK]:
    'M20 4c2.5 2.5 2 7-1.5 9.5-2.5 1.8-5.5 1.6-7.5 0L9.5 12C8 10 7.8 7 9.5 4.5 12 1 17.5 1.5 20 4zM11 13.4 7.6 16.8M14.5 6.5c1-.6 2.2-.6 3 .3M3.9999999999999996 16.6a1.6 1.6 0 1 0 3.2 0a1.6 1.6 0 1 0 -3.2 0zM5.800000000000001 18.4a1.6 1.6 0 1 0 3.2 0a1.6 1.6 0 1 0 -3.2 0z',
  [ThanksgivingIcon.FEATHER]: 'M20.2 12.2a6 6 0 0 0-8.5-8.5L5 10.5V19h8.5zM16 8 2 22M17.5 15H9',
  [ThanksgivingIcon.FOOTBALL]:
    'M20.5 3.5C14 3 8 5.5 5.5 10S3 17.5 3.5 20.5C10 21 16 18.5 18.5 14S21 6.5 20.5 3.5zM8.5 15.5l7-7M10.2 11.5l2.3 2.3M12.2 9.5l2.3 2.3M3.6 16.4l4 4M16.4 3.6l4 4',
  [ThanksgivingIcon.FORK_KNIFE]:
    'M3 2v7a2 2 0 0 0 2 2h4a2 2 0 0 0 2-2V2M7 2v20M21 15V2a5 5 0 0 0-5 5v6a2 2 0 0 0 2 2h3zm0 0v7',
  [ThanksgivingIcon.GRAPES]:
    'M6.1 9.5a1.9 1.9 0 1 0 3.8 0a1.9 1.9 0 1 0 -3.8 0zM10.1 9.5a1.9 1.9 0 1 0 3.8 0a1.9 1.9 0 1 0 -3.8 0zM14.1 9.5a1.9 1.9 0 1 0 3.8 0a1.9 1.9 0 1 0 -3.8 0zM8.1 13.5a1.9 1.9 0 1 0 3.8 0a1.9 1.9 0 1 0 -3.8 0zM12.1 13.5a1.9 1.9 0 1 0 3.8 0a1.9 1.9 0 1 0 -3.8 0zM10.1 17.5a1.9 1.9 0 1 0 3.8 0a1.9 1.9 0 1 0 -3.8 0zM12 7.5V3M12 4.5c1.5-1.5 3.5-1.5 4.5-.5',
  [ThanksgivingIcon.GRAVY_BOAT]:
    'M3 11h13c2.5 0 4-1.5 5-3.5 0 4.5-2.5 7.5-6 8.5H8c-3 0-5-2-5-5zM7.5 16 7 19.5h10l-.5-3.5M9 3.5c1 1 1 2 0 3M13 3.5c1 1 1 2 0 3',
  [ThanksgivingIcon.HAY_BALE]: 'M3 7h18v12H3zM3 11h18M3 15h18M7 7V5M12 7V4.5M17 7V5',
  [ThanksgivingIcon.HONEY_JAR]: 'M7 4h10v3H7zM6 7h12v11a3 3 0 0 1-3 3H9a3 3 0 0 1-3-3zM9 11h6v5H9z',
  [ThanksgivingIcon.LEFTOVERS]: 'M4 9h16l-2 12H6zM4 9l3-5h10l3 5M9.5 4l1 5M14.5 4l-1 5',
  [ThanksgivingIcon.MAPLE_LEAF]:
    'M12 2l1.6 3.4 2.4-1-.6 4.6 3.4-2.3.2 2.5 3-.5-1.6 3.6 1.6 1.2-5.4 3.8.6 1.9-4.6-.7M12 2l-1.6 3.4L8 4.4l.6 4.6-3.4-2.3L5 9.2l-3-.5 1.6 3.6L2 13.5l5.4 3.8-.6 1.9 4.6-.7M12 9v13',
  [ThanksgivingIcon.MUFFIN]:
    'M5 12h14l-1.5 8.5h-11zM5 12a7 6 0 0 1 14 0M9.5 12l.8 8.5M14.5 12l-.8 8.5M10.8 4.5a1.2 1.2 0 1 0 2.4 0a1.2 1.2 0 1 0 -2.4 0z',
  [ThanksgivingIcon.MUSHROOM]:
    'M3 11.5a9 7.5 0 0 1 18 0zM9 11.5l-.5 8.5a1 1 0 0 0 1 1h5a1 1 0 0 0 1-1l-.5-8.5M8 7.5h.01M15.5 6.5h.01M12 8.5h.01',
  [ThanksgivingIcon.OVEN]: 'M4 3h16v18H4zM4 8h16M7.5 11h9v7h-9zM7.5 5.5h.01M11 5.5h.01M14.5 5.5h.01',
  [ThanksgivingIcon.OVEN_MITT]: 'M7 21v-4c-1.5-1.5-2-3.5-2-6V7a4 4 0 0 1 8 0v4l3-3a2 2 0 0 1 3 2.6L14 17v4zM7 17h7',
  [ThanksgivingIcon.PARADE_BALLOON]:
    'M12 2.5A6.5 6.5 0 0 0 5.5 9c0 4 3.5 7.5 6.5 9 3-1.5 6.5-5 6.5-9A6.5 6.5 0 0 0 12 2.5zM12 18v4M10 8.5h.01M14 8.5h.01M10.5 11.5c.9.6 2.1.6 3 0',
  [ThanksgivingIcon.PEAR]:
    'M12 6c1.7 0 2.8 1.5 2.8 3.3 0 1.6 1.4 2.6 2.4 4.4A5.5 5.5 0 0 1 12 21.5a5.5 5.5 0 0 1-5.2-7.8c1-1.8 2.4-2.8 2.4-4.4C9.2 7.5 10.3 6 12 6zM12 6V3M12 4c1.5-1.5 3.5-1.5 4.5-.5-1.3 1.3-3.2 1.5-4.5.5z',
  [ThanksgivingIcon.PIE]:
    'M3 12a9 9 0 1 0 18 0a9 9 0 1 0 -18 0zM6 12a6 6 0 1 0 12 0a6 6 0 1 0 -12 0zM8 9.5h8M7.5 14.5h9M9.5 7.5v9M14.5 7.5v9',
  [ThanksgivingIcon.PIE_SLICE]: 'M3 16.5 18.5 8c1.5-.6 2.5.3 2.5 1.5v7zM3 16.5v3.5h18v-3.5M17 8c0-1.6 1-2.8 2.5-3',
  [ThanksgivingIcon.PILGRIM_HAT]: 'M7 15 8.5 4h7L17 15M3 15h18v3H3zM8 10.5h8M10.5 9h3v3h-3z',
  [ThanksgivingIcon.PLATE_SETTING]:
    'M6.5 12a5.5 5.5 0 1 0 11.0 0a5.5 5.5 0 1 0 -11.0 0zM9 12a3 3 0 1 0 6 0a3 3 0 1 0 -6 0zM3 4v4a1.5 1.5 0 0 0 3 0V4M4.5 9.5V20M21 4c-1.5 1-2.3 3-2.3 6H21v10',
  [ThanksgivingIcon.PUMPKIN]:
    'M12 6.5c-5 0-8 3-8 7.3S7.5 21 12 21s8-3 8-7.2-3-7.3-8-7.3zM12 6.5c-2 2-2.5 4.3-2.5 7.3S10 19 12 21M12 6.5c2 2 2.5 4.3 2.5 7.3S14 19 12 21M12 6.5V3.5c1 0 2 .3 2.5 1',
  [ThanksgivingIcon.ROLLING_PIN]: 'M5 14.5 14.5 5 19 9.5 9.5 19zM5.8 18.2 3 21M18.2 5.8 21 3',
  [ThanksgivingIcon.SALT_SHAKER]:
    'M7.5 21h9M8.5 21V10c0-3.5 1.5-6 3.5-6s3.5 2.5 3.5 6v11M8.5 12.5h7M11 6.8h.01M13 6.8h.01',
  [ThanksgivingIcon.SCARECROW]:
    'M7.5 7.5h9M9.5 7.5 10 3h4l.5 4.5M9.5 10.5a2.5 2.5 0 1 0 5.0 0a2.5 2.5 0 1 0 -5.0 0zM12 13v8M4 15h16M8.5 21l3.5-3.5 3.5 3.5',
  [ThanksgivingIcon.SHIP]: 'M2 18h20l-2.5 3.5h-15zM12 2v16M12 4.5 5.5 15H12M12 3.5 18.5 15H12',
  [ThanksgivingIcon.SILO]: 'M3.5 21V8a3 3 0 0 1 6 0v13M3.5 12h6M3.5 16h6M9.5 21h11v-8l-5.5-4-5.5 4M13.5 21v-4h3v4',
  [ThanksgivingIcon.SPOON]: 'M17.5 3.5c1.8 1.8 1.3 5.3-1 7.6s-5.8 2.8-7.6 1-1.3-5.3 1-7.6 5.8-2.8 7.6-1zM9 13 3 21',
  [ThanksgivingIcon.SQUASH]:
    'M12 3.5c1.7 0 2.5 1.3 2.5 3.2v3.1c2.5 1 4 3.3 4 6A6.5 6.5 0 0 1 12 22a6.5 6.5 0 0 1-6.5-6.2c0-2.7 1.5-5 4-6V6.7c0-1.9.8-3.2 2.5-3.2zM12 3.5V2M7 16h10',
  [ThanksgivingIcon.SUNFLOWER]:
    'M9 9a3 3 0 1 0 6 0a3 3 0 1 0 -6 0zM12 3V4.5M12 13.5V15M6 9h1.5M16.5 9H18M7.8 4.8l1.1 1.1M15.1 12.1l1.1 1.1M7.8 13.2l1.1-1.1M15.1 5.9l1.1-1.1M12 15v7M12 19c1.8-1.8 3.8-2.2 5-1.2',
  [ThanksgivingIcon.TABLE]: 'M3 10h18M5 10v10M19 10v10M3 10l2-3h14l2 3M9 7a3 2 0 0 1 6 0',
  [ThanksgivingIcon.TRACTOR]:
    'M3 14V9h8V4h5l3 6h1.5v4.5M12 6v4h6.5M3.5 17a3.5 3.5 0 1 0 7.0 0a3.5 3.5 0 1 0 -7.0 0zM15.5 18a2.5 2.5 0 1 0 5.0 0a2.5 2.5 0 1 0 -5.0 0zM10.5 15.5h5',
  [ThanksgivingIcon.TURKEY]:
    'M7.5 16a4.5 4.5 0 1 0 9.0 0a4.5 4.5 0 1 0 -9.0 0zM8 13.5A7.5 7.5 0 0 1 3.5 9.5M9.2 11.8a8 8 0 0 1-1.8-6.3M12 11.5V3.5M14.8 11.8a8 8 0 0 0 1.8-6.3M16 13.5a7.5 7.5 0 0 0 4.5-4M10.5 20.5V22M13.5 20.5V22M11 14.5h.01M13 14.5h.01',
  [ThanksgivingIcon.WHISK]:
    'M12 14v7.5M12 14c-3.5-1-5-4.5-5-7.5S9 2.5 12 2.5s5 1 5 4-1.5 6.5-5 7.5zM12 14c-1.4-2-2-5-2-7.5s.7-4 2-4M12 14c1.4-2 2-5 2-7.5s-.7-4-2-4',
  [ThanksgivingIcon.WISHBONE]:
    'M5.5 19.5 12 8l6.5 11.5M12 8V4M11 3a1 1 0 1 0 2 0a1 1 0 1 0 -2 0zM4.5 20a1 1 0 1 0 2 0a1 1 0 1 0 -2 0zM17.5 20a1 1 0 1 0 2 0a1 1 0 1 0 -2 0z',
};

export const THANKSGIVING_ICONS = Object.fromEntries(
  Object.values(ThanksgivingIcon).map(name => [
    name,
    defineSeasonalIcon(`Thanksgiving${name}`, ICON_PATHS[name], 'outline'),
  ]),
) as Record<ThanksgivingIcon, ReturnType<typeof defineSeasonalIcon>>;

// One distinct Thanksgiving icon per side-nav entry, keyed by the entry's label (the same labels as the Halloween map).
export const THANKSGIVING_NAV_ICONS: Record<string, ThanksgivingIcon> = {
  'A/B Tests': ThanksgivingIcon.APPLE,
  'AI Spend': ThanksgivingIcon.BONFIRE,
  'Account Admin': ThanksgivingIcon.PILGRIM_HAT,
  'Account Dashboard': ThanksgivingIcon.BARN,
  Admin: ThanksgivingIcon.CORNUCOPIA,
  Analytics: ThanksgivingIcon.PIE,
  'Analytics API': ThanksgivingIcon.COOKBOOK,
  'App Marketplace': ThanksgivingIcon.BASKET,
  'App Review': ThanksgivingIcon.SPOON,
  Apps: ThanksgivingIcon.MUFFIN,
  'Bot Pairings': ThanksgivingIcon.SCARECROW,
  Brands: ThanksgivingIcon.SUNFLOWER,
  'Child Account Dashboard': ThanksgivingIcon.SILO,
  'Child Accounts': ThanksgivingIcon.ACORN,
  'Claim Automation': ThanksgivingIcon.COOKING_POT,
  Collaborations: ThanksgivingIcon.CIDER_TOAST,
  'Control Panel': ThanksgivingIcon.OVEN,
  Customers: ThanksgivingIcon.PLATE_SETTING,
  Customizations: ThanksgivingIcon.ROLLING_PIN,
  Dashboard: ThanksgivingIcon.TURKEY,
  Developer: ThanksgivingIcon.WHISK,
  Engineering: ThanksgivingIcon.TRACTOR,
  Feedback: ThanksgivingIcon.WISHBONE,
  Finance: ThanksgivingIcon.HONEY_JAR,
  Gallery: ThanksgivingIcon.PARADE_BALLOON,
  'Global Macros': ThanksgivingIcon.CHEF_HAT,
  History: ThanksgivingIcon.CANDLE,
  Implementation: ThanksgivingIcon.HAY_BALE,
  Insights: ThanksgivingIcon.CORN,
  Integrations: ThanksgivingIcon.GRAPES,
  Macros: ThanksgivingIcon.SALT_SHAKER,
  Models: ThanksgivingIcon.MUSHROOM,
  Orders: ThanksgivingIcon.DRUMSTICK,
  Organization: ThanksgivingIcon.TABLE,
  Payments: ThanksgivingIcon.GRAVY_BOAT,
  Payouts: ThanksgivingIcon.CRANBERRY_SAUCE,
  'Post-Claim': ThanksgivingIcon.LEFTOVERS,
  Products: ThanksgivingIcon.PUMPKIN,
  Returns: ThanksgivingIcon.OVEN_MITT,
  Reviews: ThanksgivingIcon.FOOTBALL,
  Settings: ThanksgivingIcon.FORK_KNIFE,
  'Shipping Claims': ThanksgivingIcon.SHIP,
  'Store Credit': ThanksgivingIcon.PIE_SLICE,
  Stores: ThanksgivingIcon.CABIN,
  'Team Members': ThanksgivingIcon.FEATHER,
  Themes: ThanksgivingIcon.MAPLE_LEAF,
  Users: ThanksgivingIcon.CARROT,
  'Warranty Claims': ThanksgivingIcon.SQUASH,
  Whitelabel: ThanksgivingIcon.PEAR,
};
